import { render, staticRenderFns } from "./NotificationConfirmationModal.vue?vue&type=template&id=3852f91a&scoped=true"
import script from "./NotificationConfirmationModal.vue?vue&type=script&lang=js"
export * from "./NotificationConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationConfirmationModal.vue?vue&type=style&index=0&id=3852f91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852f91a",
  null
  
)

export default component.exports